import { render, staticRenderFns } from "./ContactEditAutofillModal.vue?vue&type=template&id=959bff4a"
import script from "./ContactEditAutofillModal.vue?vue&type=script&lang=ts"
export * from "./ContactEditAutofillModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports